<!-- 已迁移 -->
<template>
    <header class="header-wrap">
        <div class="logo-wrap">
            <span class="logo"></span>
            <p class="title">商家平台</p>
        </div>
        <slot></slot>
        <div class="button-warp"></div>
    </header>
</template>

<script>
// import formatUrl from '@/layout/utils/formatUrl';

export default {
    name: 'commonHeader',
    components: {},
    props: {},
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.header-wrap {
    width: 100%;
    height: 54px;
    background: #232735;
    position: relative;

    .logo-wrap {
        position: absolute;
        top: 0;

        .logo {
            display: inline-block;
            width: 147px;
            height: 37px;
            background: url('@/common/assets/logo.png') 0 0 no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 50%;
            left: 16px;
            transform: translateY(-50%);
        }

        .title {
            padding-left: 170px;
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            line-height: 54px;
        }
    }
}
</style>
